import { Button, DeleteIcon, Div, H3, Modal, P } from '@vgrubs/components';

type Props = {
  /** Id awaiting confirmation. null keeps the modal closed. */
  announcementId: number | null;
  onClose: () => void;
  onConfirm: (id: number) => void;
};

export const AnnouncementDeleteModal = ({
  announcementId,
  onClose,
  onConfirm,
}: Props) => (
  <Modal
    isOpen={announcementId != null}
    closeModal={onClose}
    logo={false}
    exitButton={false}
  >
    <Div $mb="16">
      <DeleteIcon />
    </Div>

    <H3 $m="10px" $center>
      Delete
    </H3>
    <P $mb="24" $center>
      Are you sure you want to delete this announcement?
    </P>

    <Div $flex $gap="16px">
      <Button
        $w="100%"
        $selected
        onClick={() => announcementId != null && onConfirm(announcementId)}
      >
        Delete
      </Button>
      <Button $selected $gray $w="100%" onClick={onClose}>
        Cancel
      </Button>
    </Div>
  </Modal>
);
